export enum Roles {
  PARTNER = 'partner',
}

export enum ResidentTypes {
  OWNER = 'OWNER',
  HOMEOWNER = 'HOMEOWNER',
  TENANT = 'TENANT',
}

export const selectResidentTypes = [
  {
    id: ResidentTypes.OWNER,
    label: 'Propriétaire non-occupant',
  },
  {
    id: ResidentTypes.HOMEOWNER,
    label: 'Propriétaire occupant',
  },
  {
    id: ResidentTypes.TENANT,
    label: 'Locataire',
  },
];

export const translateResidentType = (residentType: string) => {
  switch (residentType) {
    case ResidentTypes.OWNER:
      return 'Propriétaire non-occupant';
    case ResidentTypes.HOMEOWNER:
      return 'Propriétaire occupant';
    case ResidentTypes.TENANT:
      return 'Locataire';
    default:
      return '';
  }
};
